module.exports = __webpack_public_path__ + "img/add_a_favorite--active.4bd6bf3f.svg";